const initializeApp = () => {

    // Axios setup removed! It is now handled securely in utils/axios.js

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code

    } else {
        // Prod build code

        // Removing console.log from prod
        console.log = () => {};

        // init analytics here
    }
}

export default initializeApp